import type { NextHop } from "@/domain/trace";

/**
 * "Where would you like to look next?" (Trace Source spec §3.6) — derived
 * per-node from domain/trace.ts's nextHopCards (built off the up/related
 * arrays resolveTrace/resolveTraceAsync already compute), not a static
 * per-entity-type table.
 */
export function TraceNextHopCards({ hops, onWalk }: { hops: NextHop[]; onWalk: (target: NextHop["target"]) => void }) {
  if (hops.length === 0) return null;
  return (
    <div className="border-t border-line bg-subtle px-6 py-4">
      <p className="text-meta text-faint">Where would you like to look next?</p>
      <div className="mt-2.5 grid grid-cols-1 gap-2.5 sm:grid-cols-3">
        {hops.map((hop, i) => (
          <button
            key={i}
            type="button"
            onClick={() => onWalk(hop.target)}
            className="flex flex-col gap-1 rounded-lg border border-line bg-card px-3.5 py-3 text-left transition-all hover:-translate-y-px hover:border-brand hover:bg-brandSoft"
          >
            <span className="font-mono text-[10px] font-medium uppercase tracking-[0.12em] text-brand">
              {hop.arrow} {hop.verb}
            </span>
            <span className="text-[13px] font-medium text-ink">{hop.label}</span>
            {hop.hint && <span className="text-[11.5px] text-faint">{hop.hint}</span>}
          </button>
        ))}
      </div>
    </div>
  );
}
